import en from './en.json';
import ru from './ru.json';
import { i18n } from 'locales';

i18n.addResourceBundle('en', 'stock', en, true);
i18n.addResourceBundle('ru', 'stock', ru, true);
